import { createSelector } from 'reselect';

const getError = state => state.app;

const getLoggedUserAccesor = state => state.home.loggedUser.user;

export const authSelector = createSelector(getLoggedUserAccesor, state => state);

export const errorSelector = createSelector(getError, state => state);